import styles from './style.module.scss';
import { IRoadmapConfigValue } from '../../model/products';
import { getIconUrl } from '../../lib/cdn-icon-url';
import { ImgComponent } from '../components/img-component';
import classNames from 'classnames';

interface IProps {
  readonly data: IRoadmapConfigValue;
  readonly active?: boolean;
  readonly activeChange?: () => void;
}

export const RoadmapContentItem = (props: IProps) => {
  const { data } = props;
  const onClick = () => {
    if (props.activeChange) {
      props.activeChange();
    }
  }
  return (
    <div className={classNames(styles.roadmapContentItemBox, props.active ? styles.roadmapContentItemActiveBox : '')} onClick={onClick}>
      <div className={styles.itemBox}>
        <div className={styles.itemTitleBox}>
          <div className={styles.itemTitleLeftBox}>
            <ImgComponent
              key={data.iconUrl || ''}
              url={getIconUrl(data.iconUrl || '') || ''}
              className={styles.itemIcon}
            />
            <span className={styles.itemTitle}>
              {data.parentName?.toLocaleUpperCase() || ''}
            </span>
          </div>
          <div></div>
        </div>
        <div className={styles.itemServicesBox}>
          <div className={styles.itemServiceContent}>
            {data.services &&
              data.services.length !== 0 &&
              data.services.map((item) => {
                return (
                  <div className={styles.itemService}>
                    <div className={styles.itemServiceName}>
                      {item.name || ''}
                    </div>
                    <div className={styles.itemServiceDesc}>
                      {item.desc || ''}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};
